export interface DateFilterWithdrawCrypto {
  startDate: string;
  endDate: string;
}

export interface DateFilterWithdrawCryptoDto {
  start_time: string;
  end_time: string;
}

export function toDomainDateFilterDto(
  filters: DateFilterWithdrawCrypto
): DateFilterWithdrawCryptoDto {
  return {
    start_time: filters.startDate ? filters.startDate + ' 00:00:00' : '',
    end_time: filters.endDate ? filters.endDate + ' 23:59:59' : ''
  };
}
